import { Box, Group, Select, TextInput, Text, Button } from "@mantine/core";
import { useEffect, useState } from "react";
import {
  FileUpload,
  InfoCircle,
  ArrowDownCircle,
  Ban,
} from "tabler-icons-react";
import { useAuth } from "../../../../providers/AuthProvider";
import { getMetadata } from "../../../../services/bankingService";
import { ApprovalStatus, OtherInformationProps } from "../../../../types/types";
import { Heading } from "../../heading/heading";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Loader } from "../../../loader/Loader";
import '../createAccount.css';

export function OtherInformation(props: OtherInformationProps) {
  const authContext = useAuth();
  const [list, setList] = useState<any[]>([]);
  
  useEffect(() => {
    const method = async () => {
      const metaDataResult = await getMetadata();
      const configResult = metaDataResult.features.filter(
        (j: any) => j.domainName === "clientconfig" && j.domainType === "config"
      );

      const constList = configResult[0].domainValues[0].constitutionList;

      const newList: any[] = [];
      if (constList) {
        constList.forEach((item: string) => {
          newList.push({
            label: item,
            value: item,
          });
        });
        setList(newList);
      }
    };
    method();
  }, [authContext]);

  const downloadFile = (blobUrl: string, filename: string) => {
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.colors.gray[0],
        display: "flex",
        alignItems: "center",
        padding: "16px 0",
        marginTop: "10px",
        flexDirection: "column",
      })}
    >
      <Box
        sx={(theme) => ({
          width: "65%",
        })}
      >
        <Heading
          mainHeading="Other Information"
          subHeading="Please fill your other information"
        />
        <Box
          sx={() => ({
            marginTop: "16px",
          })}
        >
          <Group
            grow
            sx={() => ({
              width: "100%",
              marginTop: "12px",
              alignItems: "flex-start",
            })}
          >
            <Select
              label="WD Constitution"
              placeholder="Partnership"
              name="constitution"
              disabled={props.disableInputs}
              value={props.inputs.constitution}
              data={list}
              error={props.formValidation.constitution.message}
              onChange={(selected: string) => {
                props.handleChangeDropDown(selected, "constitution");
              }}
              required
              onKeyDown={() =>
                props.setFormValidation({
                  ...props.formValidation,
                  constitution: { message: "", isValidated: true },
                })
              }
            />
            <TextInput
              placeholder="Enter contact person name"
              label="WD contact person name"
              name="contactName"
              value={props.inputs.contactName}
              onChange={props.handleChange}
            />
          </Group>
          <Group
            grow
            sx={() => ({
              width: "100%",
              marginTop: "12px",
              alignItems: "flex-start",
            })}
          >
            <TextInput
              placeholder="Enter authorized person name"
              label="WD authorized person name"
              name="authPersonName"
              value={props.inputs.authPersonName}
              onChange={props.handleChange}
            />
            <TextInput
              placeholder="Enter Pan card no."
              label="Business PAN"
              name="pan"
              disabled={props.disableInputs}
              value={props.inputs.pan}
              onChange={props.handleChange}
              required
              error={props.formValidation.pan.message}
              onKeyDown={() =>
                props.setFormValidation({
                  ...props.formValidation,
                  pan: { message: "", isValidated: true },
                })
              }
            />
          </Group>
          <Group
            grow
            sx={() => ({
              width: "100%",
              marginTop: "12px",
              alignItems: "flex-start",
            })}
          >
            <TextInput
              placeholder="07AJIPA1572E4ZK"
              label="WD GSTIN"
              name="gstin"
              disabled={props.disableInputs}
              value={props.inputs.gstin}
              onChange={props.handleChange}
              required
              error={props.formValidation.gstin.message}
              onKeyDown={() =>
                props.setFormValidation({
                  ...props.formValidation,
                  gstin: { message: "", isValidated: true },
                })
              }
            />
            <Box
              sx={() => ({
                position: "relative",
              })}
            >
              <div
                className="chequeDownload"
                style={{ display: "flex", alignItems: "flex-end", gap: "5px" }}
              >
                <TextInput
                  style={{ width: "100%" }}
                  onClick={props.handleFileClick}
                  placeholder="Upload cancelled cheque leaf"
                  label="Upload cancelled cheque leaf"
                  name="checkLeafURL"
                  disabled={props.disableInputs}
                  required
                  value={props.selectedFile}
                  onChange={props.handleChange}
                  icon={<FileUpload size={20} strokeWidth={2} color={"gray"} />}
                  readOnly={true}
                  error={props.formValidation.checkLeafURL.message}
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      checkLeafURL: { message: "", isValidated: true },
                    })
                  }
                />

                <input
                  type="file"
                  id="file"
                  ref={props.hiddenFileInput}
                  onChange={props.handleFileChange}
                  style={{ display: "none" }}
                />

{props.blobKey && (
                      <ArrowDownCircle
                        size={25}
                        strokeWidth={2}
                        color={"gray"}
                        onClick={() => downloadFile(props.blobKey, props.selectedFile)}
                      />
                  )}
              </div>
              <Text
                sx={() => ({
                  fontSize: "8px",
                  display: "flex",
                  alignItems: "center",
                  position: "absolute",
                  marginTop: "4px",
                })}
                color="dimmed"
              >
                <InfoCircle size={10} strokeWidth={2} color={"gray"} />
                &nbsp;Only PDF file format upto 5MB is allowed
              </Text>
            </Box>
          </Group>
          <Group
            grow
            sx={() => ({
              width: "100%",
              marginTop: "12px",
              alignItems: "flex-start",
            })}
          >
            <Box
              sx={() => ({
                position: "relative",
              })}
            >
              <div
                className="chequeDownload"
                style={{ display: "flex", alignItems: "flex-end", gap: "5px" }}
              >
                <TextInput
                  style={{ width: "100%" }}
                  onClick={props.handleLetterClick}
                  placeholder="Upload authorization letter"
                  label="Upload authorization letter"
                  name="authorizationLetter"
                  disabled={props.disableInputs}
                  required
                  value={props.selectedFileLetter}
                  onChange={props.handleChange}
                  icon={<FileUpload size={20} strokeWidth={2} color={"gray"} />}
                  readOnly={true}
                  error={props.formValidation.authorizationLetter.message}
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      authorizationLetter: { message: "", isValidated: true },
                    })
                  }
                />
                <input
                  type="file"
                  id="file"
                  ref={props.hiddenLetterInput}
                  onChange={props.handleLetterChange}
                  style={{ display: "none" }}
                />
                {props.blobKeyLetter && (
                      <ArrowDownCircle
                        size={25}
                        strokeWidth={2}
                        color={"gray"}
                        onClick={() => downloadFile(props.blobKeyLetter, props.selectedFileLetter)}
                      />
                  )}
              </div>
              <Text
                sx={() => ({
                  fontSize: "8px",
                  display: "flex",
                  alignItems: "center",
                  position: "absolute",
                  marginTop: "4px",
                })}
                color="dimmed"
              >
                <InfoCircle size={10} strokeWidth={2} color={"gray"} />
                &nbsp;Only PDF file format upto 5MB is allowed
              </Text>
            </Box>
          </Group>
        </Box>
      </Box>
      <Box
        sx={() => ({
          marginTop: "50px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "65%",
          gap: "20px",
        })}
      >
        {props.declarationTextLoading ? (
          <Loader />
        ) : (
          <>
            {props.declaration.text !== "" && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.declaration.accepted}
                    onClick={() =>
                      props.setDeclaration(
                        (pre: { accepted: boolean; text: string }) => ({
                          ...pre,
                          accepted: !pre.accepted,
                        
                        })
                      )
                    }
                  />
                }
                label={
                  <p className="account-creation-declaration-lable">
                    {props.declaration.text}
                  </p>
                }
              />
            )}
            {props.comment.length > 0 && (
              <div className="rejection-message">
                <Ban size={20} strokeWidth={2} color={"red"} />
                <div className="comment-div">
                  {props.comment !== "" && (
                    <p className="comment">{props.comment}</p>
                  )}
                </div>
              </div>
            )}
            {(props.adminApproval === ApprovalStatus.INITIATE ||
              props.adminApproval === ApprovalStatus.REJECTED) && (
              <Button
                style={{
                  backgroundColor: props.declaration.accepted ? "#02BBd5" : "",
                }}
                onClick={props.submitForm}
                disabled={
                  props.declaration.text === "" &&
                  props.adminApproval === ApprovalStatus.INITIATE
                    ? false
                    : !props.declaration.accepted
                }
              >
                Request for approval
              </Button>
            )}
            {(props.adminApproval === ApprovalStatus.PENDING ||
              props.adminApproval === ApprovalStatus.APPROVED) && (
              <Button
                style={{
                  backgroundColor:
                    props.declaration.accepted &&
                    props.adminApproval === ApprovalStatus.APPROVED
                      ? "#02BBd5"
                      : "",
                }}
                onClick={props.submitForm}
                disabled={
                  props.declaration.accepted &&
                  props.adminApproval === ApprovalStatus.APPROVED
                    ? false
                    : true
                }
              >
                Validate Account
              </Button>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
